module.exports = __webpack_public_path__ + "img/g4s_1.4868b17f.png";